<template>
    <a-button :loading="buttonExcelLoading"
              class="header-btn"
              style="background-color: rgb(29, 111, 66); color: white"
              icon="file-excel" @click="exportarExcel()">
      Excel
    </a-button>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: {
      endpoint: {
        type: String
      },
      params: {
        type: Object
      },
      fileName: {
        default: 'archivo',
        type: String
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        buttonExcelLoading: false
      }
    },
    methods: {
      exportarExcel () {
        this.buttonExcelLoading = true
        this.httpClient.getInstance().get(this.endpoint, {
          params: this.params,
          responseType: 'arraybuffer'
        })
            .then(response => {
              let fileURL = new Blob([response.data], {type: response.headers['content-type']})
              fileURL = window.URL.createObjectURL(fileURL)
              let fileLink = document.getElementById('file_link_elm')
              if (fileLink === null) {
                fileLink = document.createElement('a')
                fileLink.setAttribute('id', 'file_link_elm')
                document.body.appendChild(fileLink)
              }

              fileLink.setAttribute('href', fileURL)
              fileLink.setAttribute('download', this.fileName + '.xlsx')
              fileLink.click()
              this.buttonExcelLoading = false
              Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
            })
            .catch(() => {
              this.buttonExcelLoading = false
              Mensajes.error('Error', 'No fue posible descargar el archivo.')
            })
            .then(() => {
              this.buttonExcelLoading = false
            })
      }
    }
  }
</script>

<style scoped>
  .header-btn {
    margin-right: 8px !important;
    margin-bottom: 12px !important;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/BtnExcel.vue